import React, {useState} from "react";

export default function TopStats({totalData, ga}) {
  const stats = [{name: "Total Impressions", total: totalData.tdImpressions}, {name: "Total Reads", total: totalData.reads}, {name: "Total Clickouts", total: ga["Params_Event.cta_clicks"]}, {name: "Total Revenue", total: totalData.publisherRevenue}, {name: "Avg. Read Time", total: ga["Params_Event.averageTimeSpentOnPage"]}, {name: "eCPM", total: totalData.eCpm}]
  return (
    <div>
      <dl
        className="grid grid-cols-1 divide-y divide-gray-200 overflow-hidden rounded-lg bg-white shadow md:grid-cols-6 md:divide-y-0 md:divide-x">
        {stats.map((item) => (
          <div key={item.name} className="px-4 py-5 sm:p-6">
            <dt className="text-sm font-semibold text-gray-900">
              {item.name}
            </dt>
            <dd className="sm:px-6 w-full mb-2">
              <div className="flex items-baseline text-2xl font-semibold text-indigo-600 justify-end">
                {item.name === "Avg. Read Time" ? (
                  <p className="text-xs"> s</p>
                ) : item.name === "Total Revenue" ? (
                  <p className="text-xs"> DKK</p>
                ) : (
                  ""
                )}{" "}
                {item.total !== '-' ? (Math.round(item.total * 100) / 100).toLocaleString('en-US') : '-'}
              </div>
            </dd>
          </div>
        ))}
      </dl>
    </div>
  )
}
